import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "table-transmission" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("th", null, "Pago tercero"),
  /*#__PURE__*/_createElementVNode("th", null, "Anticipo"),
  /*#__PURE__*/_createElementVNode("th", null, "Dotación"),
  /*#__PURE__*/_createElementVNode("th", null, "Apoyo sostenimiento")
], -1)
const _hoisted_3 = { class: "error-transmission" }
const _hoisted_4 = { class: "tooltip-container" }
const _hoisted_5 = { class: "tooltip-container" }
const _hoisted_6 = { class: "tooltip-container" }
const _hoisted_7 = { class: "tooltip-container" }
const _hoisted_8 = { class: "table-transmission" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("th", null, "Teletrabajo"),
  /*#__PURE__*/_createElementVNode("th", null, "Bonificación retiro"),
  /*#__PURE__*/_createElementVNode("th", null, "Indemnización"),
  /*#__PURE__*/_createElementVNode("th", null, "Reintegro")
], -1)
const _hoisted_10 = { class: "error-transmission" }
const _hoisted_11 = { class: "tooltip-container" }
const _hoisted_12 = { class: "tooltip-container" }
const _hoisted_13 = { class: "tooltip-container" }
const _hoisted_14 = { class: "tooltip-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_Tooltip = _resolveComponent("Tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("table", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("tbody", null, [
        _createElementVNode("tr", null, [
          _createElementVNode("td", null, [
            _createVNode(_component_InputNumber, {
              min: 0,
              inputId: "currency-us",
              mode: "currency",
              currency: "COP",
              locale: "es-CO",
              class: _normalizeClass(["pv-input-size", { 'p-invalid': $setup.v$.PartyPaymentAccruals.$error }]),
              minFractionDigits: 0,
              onBlur: _cache[0] || (_cache[0] = ($event: any) => ($setup.v$.PartyPaymentAccruals.$touch())),
              modelValue: $setup.PTA.ThirdPartyPaymentAccruals[0],
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.PTA.ThirdPartyPaymentAccruals[0]) = $event))
            }, null, 8, ["modelValue", "class"])
          ]),
          _createElementVNode("td", null, [
            _createVNode(_component_InputNumber, {
              min: 0,
              inputId: "currency-us",
              mode: "currency",
              currency: "COP",
              locale: "es-CO",
              class: _normalizeClass(["pv-input-size", { 'p-invalid': $setup.v$.PayrollPrepaidAccruals.$error }]),
              minFractionDigits: 0,
              modelValue: $setup.PTA.PrepaidAccruals[0],
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.PTA.PrepaidAccruals[0]) = $event)),
              onBlur: _cache[3] || (_cache[3] = ($event: any) => ($setup.v$.PayrollPrepaidAccruals.$touch()))
            }, null, 8, ["modelValue", "class"])
          ]),
          _createElementVNode("td", null, [
            _createVNode(_component_InputNumber, {
              min: 0,
              inputId: "currency-us",
              mode: "currency",
              currency: "COP",
              locale: "es-CO",
              class: _normalizeClass(["pv-input-size", { 'p-invalid': $setup.v$.Endowment.$error }]),
              minFractionDigits: 0,
              modelValue: $setup.PTA.GeneralAccruals.Endowment,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.PTA.GeneralAccruals.Endowment) = $event)),
              onBlur: _cache[5] || (_cache[5] = ($event: any) => ($setup.v$.Endowment.$touch()))
            }, null, 8, ["modelValue", "class"])
          ]),
          _createElementVNode("td", null, [
            _createVNode(_component_InputNumber, {
              min: 0,
              inputId: "currency-us",
              mode: "currency",
              currency: "COP",
              locale: "es-CO",
              class: _normalizeClass(["pv-input-size", { 'p-invalid': $setup.v$.SustainableSupport.$error }]),
              minFractionDigits: 0,
              modelValue: $setup.PTA.GeneralAccruals.SustainableSupport,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.PTA.GeneralAccruals.SustainableSupport) = $event)),
              onBlur: _cache[7] || (_cache[7] = ($event: any) => ($setup.v$.SustainableSupport.$touch()))
            }, null, 8, ["modelValue", "class"])
          ])
        ]),
        _createElementVNode("tr", _hoisted_3, [
          _createElementVNode("td", null, [
            _createElementVNode("div", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.v$.PartyPaymentAccruals.$errors, (error) => {
                return (_openBlock(), _createBlock(_component_Tooltip, {
                  key: error.$uid,
                  visible: $setup.v$.PartyPaymentAccruals.$error,
                  message: error.$message
                }, null, 8, ["visible", "message"]))
              }), 128))
            ])
          ]),
          _createElementVNode("td", null, [
            _createElementVNode("div", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.v$.PayrollPrepaidAccruals.$errors, (error) => {
                return (_openBlock(), _createBlock(_component_Tooltip, {
                  key: error.$uid,
                  visible: $setup.v$.PayrollPrepaidAccruals.$error,
                  message: error.$message
                }, null, 8, ["visible", "message"]))
              }), 128))
            ])
          ]),
          _createElementVNode("td", null, [
            _createElementVNode("div", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.v$.Endowment.$errors, (error) => {
                return (_openBlock(), _createBlock(_component_Tooltip, {
                  key: error.$uid,
                  visible: $setup.v$.Endowment.$error,
                  message: error.$message
                }, null, 8, ["visible", "message"]))
              }), 128))
            ])
          ]),
          _createElementVNode("td", null, [
            _createElementVNode("div", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.v$.SustainableSupport.$errors, (error) => {
                return (_openBlock(), _createBlock(_component_Tooltip, {
                  key: error.$uid,
                  visible: $setup.v$.SustainableSupport.$error,
                  message: error.$message
                }, null, 8, ["visible", "message"]))
              }), 128))
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("table", _hoisted_8, [
      _hoisted_9,
      _createElementVNode("tbody", null, [
        _createElementVNode("tr", null, [
          _createElementVNode("td", null, [
            _createVNode(_component_InputNumber, {
              min: 0,
              inputId: "currency-us",
              mode: "currency",
              currency: "COP",
              locale: "es-CO",
              class: _normalizeClass(["pv-input-size", { 'p-invalid': $setup.v$.Telecommuting.$error }]),
              minFractionDigits: 0,
              modelValue: $setup.PTA.GeneralAccruals.Telecommuting,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.PTA.GeneralAccruals.Telecommuting) = $event)),
              onBlur: _cache[9] || (_cache[9] = ($event: any) => ($setup.v$.Telecommuting.$touch()))
            }, null, 8, ["modelValue", "class"])
          ]),
          _createElementVNode("td", null, [
            _createVNode(_component_InputNumber, {
              min: 0,
              inputId: "currency-us",
              mode: "currency",
              currency: "COP",
              locale: "es-CO",
              class: _normalizeClass(["pv-input-size", { 'p-invalid': $setup.v$.RetirementBonus.$error }]),
              minFractionDigits: 0,
              modelValue: $setup.PTA.GeneralAccruals.RetirementBonus,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (($setup.PTA.GeneralAccruals.RetirementBonus) = $event)),
              onBlur: _cache[11] || (_cache[11] = ($event: any) => ($setup.v$.RetirementBonus.$touch()))
            }, null, 8, ["modelValue", "class"])
          ]),
          _createElementVNode("td", null, [
            _createVNode(_component_InputNumber, {
              min: 0,
              inputId: "currency-us",
              mode: "currency",
              currency: "COP",
              locale: "es-CO",
              class: _normalizeClass(["pv-input-size", { 'p-invalid': $setup.v$.Indemnification.$error }]),
              minFractionDigits: 0,
              modelValue: $setup.PTA.GeneralAccruals.Indemnification,
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (($setup.PTA.GeneralAccruals.Indemnification) = $event)),
              onBlur: _cache[13] || (_cache[13] = ($event: any) => ($setup.v$.Indemnification.$touch()))
            }, null, 8, ["modelValue", "class"])
          ]),
          _createElementVNode("td", null, [
            _createVNode(_component_InputNumber, {
              min: 0,
              inputId: "currency-us",
              mode: "currency",
              currency: "COP",
              locale: "es-CO",
              class: _normalizeClass(["pv-input-size", { 'p-invalid': $setup.v$.RefundAccrual.$error }]),
              minFractionDigits: 0,
              modelValue: $setup.PTA.GeneralAccruals.RefundAccrual,
              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (($setup.PTA.GeneralAccruals.RefundAccrual) = $event)),
              onBlur: _cache[15] || (_cache[15] = ($event: any) => ($setup.v$.RefundAccrual.$touch()))
            }, null, 8, ["modelValue", "class"])
          ])
        ]),
        _createElementVNode("tr", _hoisted_10, [
          _createElementVNode("td", null, [
            _createElementVNode("div", _hoisted_11, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.v$.Telecommuting.$errors, (error) => {
                return (_openBlock(), _createBlock(_component_Tooltip, {
                  key: error.$uid,
                  visible: $setup.v$.Telecommuting.$error,
                  message: error.$message
                }, null, 8, ["visible", "message"]))
              }), 128))
            ])
          ]),
          _createElementVNode("td", null, [
            _createElementVNode("div", _hoisted_12, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.v$.RetirementBonus.$errors, (error) => {
                return (_openBlock(), _createBlock(_component_Tooltip, {
                  key: error.$uid,
                  visible: $setup.v$.RetirementBonus.$error,
                  message: error.$message
                }, null, 8, ["visible", "message"]))
              }), 128))
            ])
          ]),
          _createElementVNode("td", null, [
            _createElementVNode("div", _hoisted_13, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.v$.Indemnification.$errors, (error) => {
                return (_openBlock(), _createBlock(_component_Tooltip, {
                  key: error.$uid,
                  visible: $setup.v$.Indemnification.$error,
                  message: error.$message
                }, null, 8, ["visible", "message"]))
              }), 128))
            ])
          ]),
          _createElementVNode("td", null, [
            _createElementVNode("div", _hoisted_14, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.v$.RefundAccrual.$errors, (error) => {
                return (_openBlock(), _createBlock(_component_Tooltip, {
                  key: error.$uid,
                  visible: $setup.v$.RefundAccrual.$error,
                  message: error.$message
                }, null, 8, ["visible", "message"]))
              }), 128))
            ])
          ])
        ])
      ])
    ])
  ], 64))
}